import { StatDisplay } from 'app/agriculture/components/StatDisplay/StatDisplay';

import { Button } from 'app/agriculture/components/Button/Button';
import { useRouteActions } from 'app/agriculture/router/useRouteActions';
import { useHerdsForEntity } from 'app/agriculture/infobox/herds/useHerdsForEntity';
import { LinkedEntityList } from 'app/agriculture/components/LinkedEntityList/LinkedEntityList';

interface HerdsForEntityProps {
    assetId: string;
}

export function HerdsForEntity({ assetId }: HerdsForEntityProps) {
    const routeActions = useRouteActions();
    const herds = useHerdsForEntity(assetId);
    return (
        <StatDisplay
            name="Herds"
            value={
                herds.length > 0 ? (
                    <LinkedEntityList entityIds={herds.map(({ id }) => id)} />
                ) : (
                    <Button
                        variant="compact"
                        text={herds.length}
                        endIcon="goto"
                        onClick={() => {
                            routeActions.openList('Herd');
                        }}
                    />
                )
            }
        />
    );
}
